import { useStore } from 'effector-react'

import { $dividendAccruals, getDividendAccrualsByDividendEventId } from './model'

export const useDividendAccrualList = () => {

  const loading = useStore(getDividendAccrualsByDividendEventId.pending)

  const dividendAccruals = useStore($dividendAccruals)

  return { dividendAccruals, loading }
}
